import React, { useEffect } from "react";
// ANT DESIGN COMPONENTS
import { Modal, Spin } from "antd";
// REDUX
import { useDispatch, useSelector } from "react-redux";
import { useDeleteActionMutation } from "../../../redux/actions/actionsAPI";
import { updateOpenModalDelete, updateAction } from "../../../redux/actions/actionsSlice";
// COMPONENTS
import ModalDeleteItemContainer from "../../components/modal/ModalDeleteItemContainer";
import GlobalAlert2 from "../../home/GlobalAlert2";
// AUTHORIZATION
import GETJwtToken from "../../../redux/authentication/authentication";
// INTERFACES
import { RootState } from "../../../app/store";
// CONSTANTS
import { BLANK_ACTION } from "../../../constants/action";

function ActionsDeleteModal() {
	// LOCAL STORAGE AND VARIABLES ******************** */
	const dispatch = useDispatch();

	// ************************************************ */
	// GLOBAL VARIABLES ******************************* */

	// ************************************************ */
	// USE STATE VARIABLES **************************** */

	// ************************************************ */
	// REDUX SLICE VARIABLES ************************** */
	const { action, openModalDelete } = useSelector((state: RootState) => state.action);

	// ************************************************ */
	// SERVICES AND API CALLS ************************* */
	const [triggerDeleteAction, { isLoading, isSuccess, isError, error, reset: resetDeleteAction }] =
		useDeleteActionMutation();

	// ************************************************ */
	// FUNCTIONS ************************************** */
	const onClickClose = () => {
		dispatch(updateOpenModalDelete(false));
	};

	const onClickDelete = async () => {
		const token = await GETJwtToken();
		triggerDeleteAction({ id: action.id, token });
		dispatch(updateAction({ ...BLANK_ACTION }));
	};

	// ************************************************* */
	// USE EFFECT ************************************** */
	useEffect(() => {
		if (openModalDelete) {
			resetDeleteAction();
		}
	}, [openModalDelete]);

	useEffect(() => {
		if (isSuccess || isError) {
			dispatch(updateOpenModalDelete(false));
		}
	}, [isSuccess, isError]);
	// ************************************************ */
	// COMPONENT ************************************** */
	return (
		<Modal onOk={onClickClose} closable={false} onCancel={onClickClose} open={openModalDelete} footer={null}>
			<Spin spinning={isLoading}>
				<ModalDeleteItemContainer name={action.label} onClickDelete={onClickDelete} onClickClose={onClickClose} />
			</Spin>
			{/** ---------------------------------------------------- */}
			{/** GLOBAL ALERT */}
			<GlobalAlert2 isError={isError} isSuccess={isSuccess} requestType='DELETE' error={error} name='Action' />
		</Modal>
	);
}

export default ActionsDeleteModal;
